import { render, staticRenderFns } from "./StatusNotifyUsersAutomation.vue?vue&type=template&id=01ae6ca4&scoped=true&"
import script from "./StatusNotifyUsersAutomation.vue?vue&type=script&lang=js&"
export * from "./StatusNotifyUsersAutomation.vue?vue&type=script&lang=js&"
import style0 from "./StatusNotifyUsersAutomation.vue?vue&type=style&index=0&id=01ae6ca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae6ca4",
  null
  
)

export default component.exports